//////// GHG 1.3
const oneThreeSchema = {
  title: "1.3 Direct Emissions from Process Sources",
  addAPI: "cat1_3AddEmissionActivityAPI",
  cat: "cat1_3",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Activity Name",
      optionsAPI: "directGHGEmissionsEmissionActivityAPI",
      required: true,
    },
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Name / Number",
      resetOnChange: false,
      required: true,
    },
    {
      key: "isFossil",
      level: 1,
      type: "select",
      label: "Fossil-origin Methane Release",
      optionsAPI: "cat1_3Fossil",
      required: true,
    },
  ],
};

export default oneThreeSchema;
